export const useGetQrCodeStore = (data) => {
  const storeId = data ? data?.qrCode?.store_id : '-';
  const storeName = data ? data?.qrCode?.store_name : '-';
  const storeMasterId = data ? data?.qrCode?.store_master_id : '-';
  const storeMasterName = data ? data?.qrCode?.store_master_name : '-';
  const storeNo = data ? data?.qrCode?.store_no : '-';

  if (data) {
    const qrCode = {
      storeId: storeId,
      storeName: storeName,
      storeMasterId: storeMasterId,
      storeMasterName: storeMasterName,
      storeNo: storeNo,
    };
    const text = JSON.stringify(qrCode);
    return text;
  }
  return '';
};
